module.exports = __webpack_public_path__ + "img/games-13.41707e4c.webp";